// extracted by mini-css-extract-plugin
export default {"main":"_15de305edf _7c5fd0823b c458651be0 fd361ef913","title":"ffe6f4dc32"};